import { TextBlockData } from '../dto/EntityRepository';
import { TextBlockType } from '../enum/EnumRepository';

export const getTextBlockLinkCaption = (block: TextBlockData): string => {
  if (block.type !== TextBlockType.LINK) return '';
  return block.caption ?? '';
};

/** 타입 변경 때 IMAGE/LINK caption이 없으면 빈 문자열로 둔다. 있으면 유지한다. */
export const getTextBlockCaptionForTypeChange = (
  block: TextBlockData,
  nextType: TextBlockType,
): string | undefined => {
  const existingCaption = 'caption' in block ? block.caption : undefined;
  if (existingCaption != null) return undefined;
  if (nextType === TextBlockType.IMAGE || nextType === TextBlockType.LINK) return '';
  return undefined;
};
